export default __webpack_public_path__ + "static/piscina-prainha-0dd6d7352bc88b40f55fc759cbe7c508.jpg";